module.exports = __webpack_public_path__ + "static/exercise-img-11-04fcd436765c7e369487fdf94b793a90.png";